import React from "react";
import LottieLoaderanim from "../../Uis/LottieLoader/LottieLoaderanim";

function Theme() {
  return <LottieLoaderanim />;
}

export default Theme;
